<div class="vendor-form-container">
    <h2 mat-dialog-title>{{isEdit ? 'Edit' : 'Add'}} Vendor</h2>
    <form [formGroup]="vendorForm" (ngSubmit)="onSubmit()">
        <mat-dialog-content>
            <div class="form-section">
                <h3>Basic Information</h3>
                <div formGroupName="name" class="row">
                    <mat-form-field appearance="outline" class="col">
                        <mat-label>Name (English)</mat-label>
                        <input matInput formControlName="en" required>
                        <mat-error *ngIf="vendorForm.get('name.en')?.invalid">Name is required</mat-error>
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="col">
                        <mat-label>Name (French)</mat-label>
                        <input matInput formControlName="fr" required>
                        <mat-error *ngIf="vendorForm.get('name.fr')?.invalid">Name is required</mat-error>
                    </mat-form-field>
                </div>
                <div class="row">
                    <mat-slide-toggle formControlName="deleted" color="warn"> Mark as deleted </mat-slide-toggle>
                </div>
            </div>
            <div class="form-section">
                <h3>Allowed Organizations</h3>
                <div formArrayName="allowedOrganisation">
                    <div *ngFor="let org of allowedOrganisations.controls; let i = index" class="row org-row">
                        <mat-form-field appearance="outline" class="col">
                            <mat-label>Organization {{i + 1}}</mat-label>
                            <input matInput [formControlName]="i"
                                (input)="$event.target.value = $event.target.value.toUpperCase()">
                        </mat-form-field>
                        <button type="button" mat-icon-button color="warn" (click)="removeOrganisation(i)">
                            <mat-icon>delete</mat-icon>
                        </button>
                    </div>
                    <button type="button" mat-stroked-button color="primary" (click)="addOrganisation()">
                        <mat-icon>add</mat-icon> Add Organization </button>
                </div>
            </div>
            <div class="form-section">
                <h3>Shops</h3>
                <div formArrayName="shops">
                    <mat-accordion>
                        <mat-expansion-panel *ngFor="let shop of shops.controls; let i = index">
                            <mat-expansion-panel-header>
                                <mat-panel-title> Shop {{i + 1}} </mat-panel-title>
                                <mat-panel-description *ngIf="shop.get('name.en')?.value">
                                    {{shop.get('name.en')?.value}} </mat-panel-description>
                            </mat-expansion-panel-header>
                            <div [formGroupName]="i">
                                <!-- Shop Name -->
                                <div formGroupName="name" class="row">
                                    <mat-form-field appearance="outline" class="col">
                                        <mat-label>Shop Name (English)</mat-label>
                                        <input matInput formControlName="en" required>
                                    </mat-form-field>
                                    <mat-form-field appearance="outline" class="col">
                                        <mat-label>Shop Name (French)</mat-label>
                                        <input matInput formControlName="fr" required>
                                    </mat-form-field>
                                </div>
                                <!-- Shop Description -->
                                <div formGroupName="description" class="row">
                                    <mat-form-field appearance="outline" class="col">
                                        <mat-label>Description (English)</mat-label>
                                        <textarea matInput formControlName="en" rows="3"></textarea>
                                    </mat-form-field>
                                    <mat-form-field appearance="outline" class="col">
                                        <mat-label>Description (French)</mat-label>
                                        <textarea matInput formControlName="fr" rows="3"></textarea>
                                    </mat-form-field>
                                </div>
                                <!-- Shop Pictures -->
                                <div class="row">
                                    <h4>Pictures</h4>
                                    <div class="col">
                                        <div formArrayName="pictures" class="pictures-container">
                                            <div *ngFor="let picture of getPictures(i).controls; let j = index"
                                                class="picture-item">
                                                <mat-form-field appearance="outline"
                                                    style="width: 100%; margin-bottom: 10px;">
                                                    <mat-label>Image URL {{j + 1}}</mat-label>
                                                    <input matInput [formControlName]="j">
                                                </mat-form-field>
                                                <!-- Only show upload controls if no image exists yet -->
                                                <div class="upload-controls" *ngIf="!getPictures(i).at(j).value">
                                                    <input type="file" #fileInput (change)="onFileSelected($event)"
                                                        accept="image/*" style="display: none">
                                                    <button type="button" mat-stroked-button color="primary"
                                                        (click)="fileInput.click()">
                                                        <mat-icon>attach_file</mat-icon> Choose File </button>
                                                    <button type="button" mat-stroked-button color="accent"
                                                        [disabled]="!selectedFile || isUploading"
                                                        (click)="uploadImage(i, j)">
                                                        <mat-icon>cloud_upload</mat-icon>
                                                        <span *ngIf="!isUploading">Upload</span>
                                                        <span *ngIf="isUploading">Uploading...</span>
                                                    </button>
                                                </div>
                                                <!-- Only show delete button when a picture URL exists -->
                                                <div class="action-buttons">
                                                    <button type="button" mat-icon-button color="warn"
                                                        (click)="removePicture(i, j)">
                                                        <mat-icon>delete</mat-icon>
                                                    </button>
                                                </div>
                                                <!-- Image preview if URL exists -->
                                                <div *ngIf="getPictures(i).at(j).value" class="picture-preview">
                                                    <img [src]="getPictures(i).at(j).value" alt="Shop"
                                                        class="preview-image">
                                                </div>
                                            </div>
                                            <button type="button" mat-stroked-button color="primary"
                                                (click)="addPicture(i)">
                                                <mat-icon>add</mat-icon> Add Picture </button>
                                        </div>
                                    </div>
                                </div>
                                <br>
                                <!-- Shop Icon -->
                                <div class="row">
                                    <h4>Shop Icon</h4>
                                    <div class="col">
                                        <div class="icon-container">
                                            <mat-form-field appearance="outline"
                                                style="width: 100%; margin-bottom: 10px;">
                                                <mat-label>Icon URL</mat-label>
                                                <input matInput formControlName="icon">
                                            </mat-form-field>
                                            <!-- Only show upload controls if no icon exists yet -->
                                            <div class="upload-controls" *ngIf="!shop.get('icon')?.value">
                                                <input type="file" #iconFileInput
                                                    (change)="onIconFileSelected($event, i)" accept="image/*"
                                                    style="display: none">
                                                <button type="button" mat-stroked-button color="primary"
                                                    (click)="iconFileInput.click()">
                                                    <mat-icon>attach_file</mat-icon> Choose Icon </button>
                                                <button type="button" mat-stroked-button color="accent"
                                                    [disabled]="!selectedIconFile || isUploadingIcon"
                                                    (click)="uploadShopIcon(i)">
                                                    <mat-icon>cloud_upload</mat-icon>
                                                    <span *ngIf="!isUploadingIcon">Upload</span>
                                                    <span *ngIf="isUploadingIcon">Uploading...</span>
                                                </button>
                                            </div>
                                            <!-- Only show delete button when an icon URL exists -->
                                            <div class="action-buttons" *ngIf="shop.get('icon')?.value">
                                                <button type="button" mat-icon-button color="warn"
                                                    (click)="removeShopIcon(i)">
                                                    <mat-icon>delete</mat-icon>
                                                </button>
                                            </div>
                                            <!-- Icon preview if URL exists -->
                                            <div *ngIf="shop.get('icon')?.value" class="icon-preview">
                                                <img [src]="shop.get('icon')?.value" alt="Shop Icon"
                                                    class="preview-image"
                                                    style="max-width: 64px; max-height: 64px; border-radius: 8px;">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <br>
                                <!-- Website and Basic Info -->
                                <div class="row">
                                    <mat-form-field appearance="outline" class="col">
                                        <mat-label>Website</mat-label>
                                        <input matInput formControlName="website">
                                    </mat-form-field>
                                    <mat-form-field appearance="outline" class="col">
                                        <mat-label>Timezone</mat-label>
                                        <input matInput formControlName="timezone">
                                    </mat-form-field>
                                </div>
                                <br>
                                <div class="row">
                                    <div class="col">
                                        <mat-slide-toggle formControlName="onHomepage" color="primary"> Show on homepage
                                        </mat-slide-toggle>
                                    </div>
                                    <div class="col">
                                        <mat-slide-toggle formControlName="deleted" color="warn"> Mark as deleted
                                        </mat-slide-toggle>
                                    </div>
                                </div>
                                <br>
                                <!-- Shop Address -->
                                <div formGroupName="address">
                                    <h4>Address</h4>
                                    <div class="row">
                                        <mat-form-field appearance="outline" class="col">
                                            <mat-label>Street</mat-label>
                                            <input matInput formControlName="street">
                                        </mat-form-field>
                                        <mat-form-field appearance="outline" class="col">
                                            <mat-label>Street Type</mat-label>
                                            <input matInput formControlName="typeStreet">
                                        </mat-form-field>
                                    </div>
                                    <div class="row">
                                        <mat-form-field appearance="outline" class="col">
                                            <mat-label>Street Name</mat-label>
                                            <input matInput formControlName="streetName">
                                        </mat-form-field>
                                        <mat-form-field appearance="outline" class="col">
                                            <mat-label>Street Number</mat-label>
                                            <input matInput formControlName="number">
                                        </mat-form-field>
                                        <mat-form-field appearance="outline" class="col">
                                            <mat-label>Direction</mat-label>
                                            <input matInput formControlName="direction">
                                        </mat-form-field>
                                        <mat-form-field appearance="outline" class="col">
                                            <mat-label>Unit</mat-label>
                                            <input matInput formControlName="unit">
                                        </mat-form-field>
                                    </div>
                                    <div class="row">
                                        <mat-form-field appearance="outline" class="col">
                                            <mat-label>City</mat-label>
                                            <input matInput formControlName="city">
                                        </mat-form-field>
                                        <mat-form-field appearance="outline" class="col">
                                            <mat-label>Province</mat-label>
                                            <input matInput formControlName="province">
                                        </mat-form-field>
                                    </div>
                                    <div class="row">
                                        <mat-form-field appearance="outline" class="col">
                                            <mat-label>Postal Code</mat-label>
                                            <input matInput formControlName="postCode">
                                        </mat-form-field>
                                        <mat-form-field appearance="outline" class="col">
                                            <mat-label>Country</mat-label>
                                            <input matInput formControlName="country">
                                        </mat-form-field>
                                    </div>
                                    <div formGroupName="coordinates">
                                        <h5>Coordinates</h5>
                                        <div class="row">
                                            <mat-form-field appearance="outline" class="col">
                                                <mat-label>Type</mat-label>
                                                <input matInput formControlName="type">
                                            </mat-form-field>
                                        </div>
                                        <div class="row" formArrayName="coordinates">
                                            <mat-form-field appearance="outline" class="col">
                                                <mat-label>Longitude</mat-label>
                                                <input matInput [formControlName]="0" type="number">
                                            </mat-form-field>
                                            <mat-form-field appearance="outline" class="col">
                                                <mat-label>Latitude</mat-label>
                                                <input matInput [formControlName]="1" type="number">
                                            </mat-form-field>
                                        </div>
                                    </div>
                                </div>
                                <br>
                                <h4>Contact</h4>
                                <!-- Contact Information -->
                                <div formGroupName="contact" class="row">
                                    <mat-form-field appearance="outline" class="col">
                                        <mat-label>Phone</mat-label>
                                        <input matInput formControlName="phone">
                                    </mat-form-field>
                                    <mat-form-field appearance="outline" class="col">
                                        <mat-label>Email</mat-label>
                                        <input matInput formControlName="email" type="email">
                                        <mat-error *ngIf="shop.get('contact.email')?.invalid"> Please enter a valid
                                            email address </mat-error>
                                    </mat-form-field>
                                </div>
                                <!-- Social Media Information -->
                                <div formGroupName="socialMedia">
                                    <h4>Social Media</h4>
                                    <div class="row">
                                        <mat-form-field appearance="outline" class="col">
                                            <mat-label>Facebook</mat-label>
                                            <input matInput formControlName="facebook">
                                        </mat-form-field>
                                        <mat-form-field appearance="outline" class="col">
                                            <mat-label>Instagram</mat-label>
                                            <input matInput formControlName="instagram">
                                        </mat-form-field>
                                    </div>
                                    <div class="row">
                                        <mat-form-field appearance="outline" class="col">
                                            <mat-label>Google</mat-label>
                                            <input matInput formControlName="google">
                                        </mat-form-field>
                                        <mat-form-field appearance="outline" class="col">
                                            <mat-label>Other</mat-label>
                                            <input matInput formControlName="other">
                                        </mat-form-field>
                                    </div>
                                </div>
                                <!-- Schedules -->
                                <div formGroupName="schedules">
                                    <h4>Schedule</h4>
                                    <mat-slide-toggle formControlName="displaySchedules" color="primary"> Display
                                        Schedules </mat-slide-toggle>
                                    <div formArrayName="schedules">
                                        <div *ngFor="let schedule of getShopSchedules(i).controls; let j = index">
                                            <div [formGroupName]="j">
                                                <div formGroupName="schedule">
                                                    <table class="schedule-table">
                                                        <thead>
                                                            <tr>
                                                                <th>Day</th>
                                                                <th>From</th>
                                                                <th>To</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr *ngFor="let day of days" [formGroupName]="day">
                                                                <td>{{day}}</td>
                                                                <td>
                                                                    <mat-form-field appearance="outline">
                                                                        <input matInput type="time"
                                                                            formControlName="from">
                                                                    </mat-form-field>
                                                                </td>
                                                                <td>
                                                                    <mat-form-field appearance="outline">
                                                                        <input matInput type="time"
                                                                            formControlName="to">
                                                                    </mat-form-field>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- Promotions -->
                                <div>
                                    <h4>Promotions</h4>
                                    <div formArrayName="promotions">
                                        <mat-card *ngFor="let promotion of getPromotions(i).controls; let j = index"
                                            class="promotion-card" [formGroupName]="j">
                                            <mat-card-header>
                                                <mat-card-title>Promotion {{j + 1}}</mat-card-title>
                                                <button type="button" mat-icon-button color="warn"
                                                    (click)="removePromotion(i, j)" class="remove-promotion-btn">
                                                    <mat-icon>delete</mat-icon>
                                                </button>
                                            </mat-card-header>
                                            <mat-card-content>
                                                <!-- Tag Description -->
                                                <div formGroupName="tagDescription" class="row">
                                                    <mat-form-field appearance="outline" class="col">
                                                        <mat-label>Tag Description (English)</mat-label>
                                                        <input matInput formControlName="en" required>
                                                        <mat-error *ngIf="promotion.get('tagDescription.en')?.invalid">
                                                            Tag description is required </mat-error>
                                                    </mat-form-field>
                                                    <mat-form-field appearance="outline" class="col">
                                                        <mat-label>Tag Description (French)</mat-label>
                                                        <input matInput formControlName="fr" required>
                                                        <mat-error *ngIf="promotion.get('tagDescription.fr')?.invalid">
                                                            Tag description is required </mat-error>
                                                    </mat-form-field>
                                                </div>
                                                <!-- Full Description -->
                                                <div formGroupName="fullDescription" class="row">
                                                    <mat-form-field appearance="outline" class="col">
                                                        <mat-label>Full Description (English)</mat-label>
                                                        <textarea matInput formControlName="en" rows="3"></textarea>
                                                    </mat-form-field>
                                                    <mat-form-field appearance="outline" class="col">
                                                        <mat-label>Full Description (French)</mat-label>
                                                        <textarea matInput formControlName="fr" rows="3"></textarea>
                                                    </mat-form-field>
                                                </div>
                                                <!-- Colors and Icon -->
                                                <div class="row">
                                                    <mat-form-field appearance="outline" class="col">
                                                        <mat-label>Background Color</mat-label>
                                                        <input matInput formControlName="backgroundColor" type="color">
                                                    </mat-form-field>
                                                    <mat-form-field appearance="outline" class="col">
                                                        <mat-label>Text Color</mat-label>
                                                        <input matInput formControlName="textColor" type="color">
                                                    </mat-form-field>
                                                    <mat-form-field appearance="outline" class="col">
                                                        <mat-label>Icon</mat-label>
                                                        <input matInput formControlName="icon">
                                                    </mat-form-field>
                                                </div>
                                                <!-- Start Date -->
                                                <div class="row">
                                                    <mat-form-field appearance="outline" class="col">
                                                        <mat-label>Start Date</mat-label>
                                                        <input matInput [matDatepicker]="picker"
                                                            [value]="promotion.get('startDate')?.value | date:'yyyy-MM-dd'"
                                                            (dateChange)="promotion.get('startDate')?.setValue($event.value.toISOString())">
                                                        <mat-datepicker-toggle matSuffix
                                                            [for]="picker"></mat-datepicker-toggle>
                                                        <mat-datepicker #picker></mat-datepicker>
                                                    </mat-form-field>
                                                </div>
                                                <!-- End Date -->
                                                <div class="row">
                                                    <mat-form-field appearance="outline" class="col">
                                                        <mat-label>End Date</mat-label>
                                                        <input matInput [matDatepicker]="picker"
                                                            [value]="promotion.get('endDate')?.value | date:'yyyy-MM-dd'"
                                                            (dateChange)="promotion.get('endDate')?.setValue($event.value.toISOString())">
                                                        <mat-datepicker-toggle matSuffix
                                                            [for]="picker"></mat-datepicker-toggle>
                                                        <mat-datepicker #picker></mat-datepicker>
                                                    </mat-form-field>
                                                </div>
                                            </mat-card-content>
                                        </mat-card>
                                        <div class="action-row">
                                            <button type="button" mat-stroked-button color="primary"
                                                (click)="addPromotion(i)">
                                                <mat-icon>add</mat-icon> Add Promotion </button>
                                        </div>
                                    </div>
                                </div>
                                <!-- Shop Items -->
                                <div>
                                    <h4>Shop Items</h4>
                                    <div formArrayName="items">
                                        <mat-card *ngFor="let item of getItems(i).controls; let j = index"
                                            class="item-card" [formGroupName]="j">
                                            <mat-card-header>
                                                <mat-card-title>Item {{j + 1}}</mat-card-title>
                                                <button type="button" mat-icon-button color="warn"
                                                    (click)="removeItem(i, j)" class="remove-item-btn">
                                                    <mat-icon>delete</mat-icon>
                                                </button>
                                            </mat-card-header>
                                            <mat-card-content>
                                                <!-- Item Name -->
                                                <div formGroupName="name" class="row">
                                                    <mat-form-field appearance="outline" class="col">
                                                        <mat-label>Item Name (English)</mat-label>
                                                        <input matInput formControlName="en" required>
                                                        <mat-error *ngIf="item.get('name.en')?.invalid">
                                                            Item name is required
                                                        </mat-error>
                                                    </mat-form-field>
                                                    <mat-form-field appearance="outline" class="col">
                                                        <mat-label>Item Name (French)</mat-label>
                                                        <input matInput formControlName="fr" required>
                                                        <mat-error *ngIf="item.get('name.fr')?.invalid">
                                                            Item name is required
                                                        </mat-error>
                                                    </mat-form-field>
                                                </div>
                                                <!-- Item Description -->
                                                <div formGroupName="description" class="row">
                                                    <mat-form-field appearance="outline" class="col">
                                                        <mat-label>Description (English)</mat-label>
                                                        <textarea matInput formControlName="en" rows="3"></textarea>
                                                    </mat-form-field>
                                                    <mat-form-field appearance="outline" class="col">
                                                        <mat-label>Description (French)</mat-label>
                                                        <textarea matInput formControlName="fr" rows="3"></textarea>
                                                    </mat-form-field>
                                                </div>
                                                <!-- Item Type and Category -->
                                                <div class="row">
                                                    <mat-form-field appearance="outline" class="col">
                                                        <mat-label>Item Type</mat-label>
                                                        <mat-select formControlName="type">
                                                            <mat-option value="SUBSCRIPTION">Subscription</mat-option>
                                                            <mat-option value="TICKET">Ticket</mat-option>
                                                            <mat-option value="DONATION">Donation</mat-option>
                                                        </mat-select>
                                                    </mat-form-field>
                                                    <mat-form-field appearance="outline" class="col">
                                                        <mat-label>Category Type</mat-label>
                                                        <mat-select formControlName="categoryType">
                                                            <mat-option value="LEISURE">Leisure</mat-option>
                                                            <mat-option value="LIBRARY">Library</mat-option>
                                                            <mat-option value="SWIMMINGPOOL">Swimming Pool</mat-option>
                                                            <mat-option value="GYM">Gym</mat-option>
                                                            <mat-option value="OTHER">Other</mat-option>
                                                        </mat-select>
                                                    </mat-form-field>
                                                </div>
                                                <!-- Item Details -->
                                                <div formGroupName="itemDetails">
                                                    <h5>Item Details</h5>
                                                    <div class="row">
                                                        <mat-form-field appearance="outline" class="col">
                                                            <mat-label>Cost</mat-label>
                                                            <input matInput type="number" formControlName="cost" step="0.01">
                                                        </mat-form-field>
                                                        <mat-form-field appearance="outline" class="col">
                                                            <mat-label>Renewal Cost</mat-label>
                                                            <input matInput type="number" formControlName="renewalCost" step="0.01">
                                                        </mat-form-field>
                                                    </div>
                                                    <div class="row">
                                                        <mat-form-field appearance="outline" class="col">
                                                            <mat-label>Duration Type</mat-label>
                                                            <mat-select formControlName="durationType">
                                                                <mat-option value="FIXED">Fixed</mat-option>
                                                                <mat-option value="START_TODAY">Start Today</mat-option>
                                                                <mat-option value="START_AT">Start At</mat-option>
                                                            </mat-select>
                                                        </mat-form-field>
                                                        <mat-form-field appearance="outline" class="col">
                                                            <mat-label>Duration (Days)</mat-label>
                                                            <input matInput type="number" formControlName="durationDays">
                                                        </mat-form-field>
                                                    </div>
                                                    <div class="row">
                                                        <mat-form-field appearance="outline" class="col">
                                                            <mat-label>Code</mat-label>
                                                            <input matInput formControlName="code">
                                                        </mat-form-field>
                                                        <mat-form-field appearance="outline" class="col">
                                                            <mat-label>Renewal Duration (Days)</mat-label>
                                                            <input matInput type="number" formControlName="renewalDurationDays">
                                                        </mat-form-field>
                                                    </div>
                                                    <div class="row">
                                                        <mat-form-field appearance="outline" class="col">
                                                            <mat-label>Subscription Type</mat-label>
                                                            <mat-select formControlName="subscriptionType">
                                                                <mat-option value="INDIVIDUAL">Individual</mat-option>
                                                                <mat-option value="FAMILY">Family</mat-option>
                                                                <mat-option value="HERITED">Herited</mat-option>
                                                            </mat-select>
                                                        </mat-form-field>
                                                        <mat-form-field appearance="outline" class="col">
                                                            <mat-label>Category</mat-label>
                                                            <mat-select formControlName="category">
                                                                <mat-option value="DONATION">Donation</mat-option>
                                                                <mat-option value="RE_LEISURE">RE-Leisure</mat-option>
                                                                <mat-option value="RE_LIBRARY">RE-Library</mat-option>
                                                                <mat-option value="RE_OTHER">RE-Other</mat-option>
                                                                <mat-option value="RE_PARC">RE-Parc</mat-option>
                                                                <mat-option value="RE_POOL">RE-Pool</mat-option>
                                                                <mat-option value="RE_TENNIS">RE-Tennis</mat-option>
                                                                <mat-option value="NR_LEISURE">NR-Leisure</mat-option>
                                                                <mat-option value="NR_LIBRARY">NR-Library</mat-option>
                                                                <mat-option value="NR_OTHER">NR-Other</mat-option>
                                                                <mat-option value="NR_PARC">NR-Parc</mat-option>
                                                                <mat-option value="NR_POOL">NR-Pool</mat-option>
                                                                <mat-option value="NR_TENNIS">NR-Tennis</mat-option>
                                                            </mat-select>
                                                        </mat-form-field>
                                                    </div>
                                                    <div class="row">
                                                        <mat-form-field appearance="outline" class="col">
                                                            <mat-label>Card Type</mat-label>
                                                            <mat-select formControlName="cardType">
                                                                <mat-option value="LIBRARY">Library</mat-option>
                                                                <mat-option value="SPORTS">Sports</mat-option>
                                                                <mat-option value="CITIZEN">Citizen</mat-option>
                                                                <mat-option value="BCITI">BCITI</mat-option>
                                                                <mat-option value="LEGACY">Legacy</mat-option>
                                                            </mat-select>
                                                        </mat-form-field>
                                                        <div class="col">
                                                            <mat-slide-toggle formControlName="isLegacyConnector" color="primary">
                                                                Legacy Connector
                                                            </mat-slide-toggle>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <mat-form-field appearance="outline" class="col">
                                                            <mat-label>Fixed Start Date</mat-label>
                                                            <input matInput [matDatepicker]="fixedStartPicker"
                                                                [value]="item.get('itemDetails.fixedStartDate')?.value | date:'yyyy-MM-dd'"
                                                                (dateChange)="item.get('itemDetails.fixedStartDate')?.setValue($event.value?.toISOString() || null)">
                                                            <mat-datepicker-toggle matSuffix [for]="fixedStartPicker"></mat-datepicker-toggle>
                                                            <mat-datepicker #fixedStartPicker></mat-datepicker>
                                                        </mat-form-field>
                                                        <mat-form-field appearance="outline" class="col">
                                                            <mat-label>Fixed End Date</mat-label>
                                                            <input matInput [matDatepicker]="fixedEndPicker"
                                                                [value]="item.get('itemDetails.fixedEndDate')?.value | date:'yyyy-MM-dd'"
                                                                (dateChange)="item.get('itemDetails.fixedEndDate')?.setValue($event.value?.toISOString() || null)">
                                                            <mat-datepicker-toggle matSuffix [for]="fixedEndPicker"></mat-datepicker-toggle>
                                                            <mat-datepicker #fixedEndPicker></mat-datepicker>
                                                        </mat-form-field>
                                                    </div>
                                                    <div class="row">
                                                        <mat-form-field appearance="outline" class="col">
                                                            <mat-label>Custom Start Date</mat-label>
                                                            <input matInput [matDatepicker]="customStartPicker"
                                                                [value]="item.get('itemDetails.customStartDate')?.value | date:'yyyy-MM-dd'"
                                                                (dateChange)="item.get('itemDetails.customStartDate')?.setValue($event.value?.toISOString() || null)">
                                                            <mat-datepicker-toggle matSuffix [for]="customStartPicker"></mat-datepicker-toggle>
                                                            <mat-datepicker #customStartPicker></mat-datepicker>
                                                        </mat-form-field>
                                                    </div>
                                                    <!-- Short Description -->
                                                    <div formGroupName="shortDescription">
                                                        <h6>Short Description</h6>
                                                        <div class="row">
                                                            <mat-form-field appearance="outline" class="col">
                                                                <mat-label>Short Description (English)</mat-label>
                                                                <textarea matInput formControlName="en" rows="2"></textarea>
                                                            </mat-form-field>
                                                            <mat-form-field appearance="outline" class="col">
                                                                <mat-label>Short Description (French)</mat-label>
                                                                <textarea matInput formControlName="fr" rows="2"></textarea>
                                                            </mat-form-field>
                                                        </div>
                                                    </div>
                                                </div>
                                                <!-- Sale Dates -->
                                                <div class="row">
                                                    <mat-form-field appearance="outline" class="col">
                                                        <mat-label>Start Sale Date</mat-label>
                                                        <input matInput [matDatepicker]="startSalePicker"
                                                            [value]="item.get('startSale')?.value | date:'yyyy-MM-dd'"
                                                            (dateChange)="item.get('startSale')?.setValue($event.value.toISOString())">
                                                        <mat-datepicker-toggle matSuffix [for]="startSalePicker"></mat-datepicker-toggle>
                                                        <mat-datepicker #startSalePicker></mat-datepicker>
                                                    </mat-form-field>
                                                    <mat-form-field appearance="outline" class="col">
                                                        <mat-label>End Sale Date</mat-label>
                                                        <input matInput [matDatepicker]="endSalePicker"
                                                            [value]="item.get('endSale')?.value | date:'yyyy-MM-dd'"
                                                            (dateChange)="item.get('endSale')?.setValue($event.value?.toISOString() || null)">
                                                        <mat-datepicker-toggle matSuffix [for]="endSalePicker"></mat-datepicker-toggle>
                                                        <mat-datepicker #endSalePicker></mat-datepicker>
                                                    </mat-form-field>
                                                </div>
                                                <!-- Quantity and Status -->
                                                <div class="row">
                                                    <mat-form-field appearance="outline" class="col">
                                                        <mat-label>Quantity</mat-label>
                                                        <input matInput type="number" formControlName="quantity">
                                                    </mat-form-field>
                                                    <mat-form-field appearance="outline" class="col">
                                                        <mat-label>Quantity Sold</mat-label>
                                                        <input matInput type="number" formControlName="quantitySold" readonly>
                                                    </mat-form-field>
                                                </div>
                                                <div class="row">
                                                    <mat-form-field appearance="outline" class="col">
                                                        <mat-label>Quantity Booked</mat-label>
                                                        <input matInput type="number" formControlName="quantityBooked" readonly>
                                                    </mat-form-field>
                                                </div>
                                                <div class="row">
                                                    <div class="col">
                                                        <mat-slide-toggle formControlName="isPublic" color="primary">
                                                            Public Item
                                                        </mat-slide-toggle>
                                                    </div>
                                                    <div class="col">
                                                        <mat-slide-toggle formControlName="deleted" color="warn">
                                                            Mark as Deleted
                                                        </mat-slide-toggle>
                                                    </div>
                                                </div>
                                                <!-- Fees -->
                                                <div formGroupName="fees">
                                                    <h5>Fees</h5>
                                                    <div class="row">
                                                        <mat-form-field appearance="outline" class="col">
                                                            <mat-label>Fixed Amount</mat-label>
                                                            <input matInput type="number" formControlName="fixedAmount" step="0.01">
                                                        </mat-form-field>
                                                        <mat-form-field appearance="outline" class="col">
                                                            <mat-label>Percentage Amount</mat-label>
                                                            <input matInput type="number" formControlName="percentageAmount" step="0.01">
                                                        </mat-form-field>
                                                    </div>
                                                    <div class="row">
                                                        <mat-form-field appearance="outline" class="col">
                                                            <mat-label>Min Price</mat-label>
                                                            <input matInput type="number" formControlName="minPrice" step="0.01">
                                                        </mat-form-field>
                                                        <mat-form-field appearance="outline" class="col">
                                                            <mat-label>Max Price</mat-label>
                                                            <input matInput type="number" formControlName="maxPrice" step="0.01">
                                                        </mat-form-field>
                                                    </div>
                                                </div>
                                                <!-- Conditions -->
                                                <div formGroupName="conditions">
                                                    <h5>Conditions</h5>
                                                    <div class="row">
                                                        <mat-form-field appearance="outline" class="col">
                                                            <mat-label>Min Age</mat-label>
                                                            <input matInput type="number" formControlName="minAge">
                                                        </mat-form-field>
                                                        <mat-form-field appearance="outline" class="col">
                                                            <mat-label>Max Age</mat-label>
                                                            <input matInput type="number" formControlName="maxAge">
                                                        </mat-form-field>
                                                    </div>
                                                </div>
                                            </mat-card-content>
                                        </mat-card>
                                        <div class="action-row">
                                            <button type="button" mat-stroked-button color="primary"
                                                (click)="addItem(i)">
                                                <mat-icon>add</mat-icon> Add Item
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <!-- Keywords -->
                                <div>
                                    <h4>Keywords</h4>
                                    <div formGroupName="keywords" class="row">
                                        <mat-form-field appearance="outline" class="col">
                                            <mat-label>Keywords (English)</mat-label>
                                            <textarea matInput formControlName="en" rows="2"
                                                placeholder="Enter keywords separated by commas"></textarea>
                                        </mat-form-field>
                                        <mat-form-field appearance="outline" class="col">
                                            <mat-label>Keywords (French)</mat-label>
                                            <textarea matInput formControlName="fr" rows="2"
                                                placeholder="Entrez les mots-clés séparés par des virgules"></textarea>
                                        </mat-form-field>
                                    </div>
                                </div>
                                <!-- Missing Shop Category -->
                                <div formGroupName="shopCategory">
                                    <h4>Shop Category</h4>
                                    <div class="row">
                                        <mat-form-field appearance="outline" class="col">
                                            <mat-label>Categories (English)</mat-label>
                                            <textarea matInput formControlName="en" rows="2"
                                                placeholder="Enter categories separated by commas"></textarea>
                                        </mat-form-field>
                                        <mat-form-field appearance="outline" class="col">
                                            <mat-label>Categories (French)</mat-label>
                                            <textarea matInput formControlName="fr" rows="2"
                                                placeholder="Entrez les catégories séparées par des virgules"></textarea>
                                        </mat-form-field>
                                    </div>
                                </div>
                                <br>
                                <!-- Additional Shop Fields -->
                                <div class="row">
                                    <mat-form-field appearance="outline" class="col">
                                        <mat-label>Gateway Token</mat-label>
                                        <input matInput formControlName="gatewayToken">
                                    </mat-form-field>
                                    <mat-form-field appearance="outline" class="col">
                                        <mat-label>Order</mat-label>
                                        <input matInput type="number" formControlName="order">
                                    </mat-form-field>
                                </div>
                                <div class="row">
                                    <mat-form-field appearance="outline" class="col">
                                        <mat-label>Likes</mat-label>
                                        <input matInput type="number" formControlName="likes" readonly>
                                    </mat-form-field>
                                </div>
                                <br>
                                <!-- Shop Organizations -->
                                <div>
                                    <h4>Organizations</h4>
                                    <div formArrayName="organisations">
                                        <div *ngFor="let org of getShopOrganisations(i).controls; let j = index"
                                            class="row org-row">
                                            <mat-form-field appearance="outline" class="col">
                                                <mat-label>Organization {{j + 1}}</mat-label>
                                                <input matInput [formControlName]="j"
                                                    (input)="$event.target.value = $event.target.value.toUpperCase()">
                                            </mat-form-field>
                                            <button type="button" mat-icon-button color="warn"
                                                (click)="removeShopOrganisation(i, j)">
                                                <mat-icon>delete</mat-icon>
                                            </button>
                                        </div>
                                        <button type="button" mat-stroked-button color="primary"
                                            (click)="addShopOrganisation(i)">
                                            <mat-icon>add</mat-icon> Add Organization </button>
                                    </div>
                                </div>
                            </div>
                            <mat-action-row>
                                <button type="button" mat-button color="warn" (click)="removeShop(i)">Remove
                                    Shop</button>
                            </mat-action-row>
                        </mat-expansion-panel>
                    </mat-accordion>
                    <div class="action-row">
                        <button type="button" mat-stroked-button color="primary" (click)="addShop()">
                            <mat-icon>add</mat-icon> Add Shop </button>
                    </div>
                </div>
            </div>
        </mat-dialog-content>
        <mat-dialog-actions align="end">
            <button type="button" mat-button [disabled]="isSubmitting" (click)="onCancel()">Cancel</button>
            <button type="submit" mat-raised-button color="primary" [disabled]="isSubmitting">
                <mat-spinner *ngIf="isSubmitting" [diameter]="20"></mat-spinner>
                <span *ngIf="!isSubmitting">{{isEdit ? 'Update' : 'Save'}}</span>
            </button>
        </mat-dialog-actions>
    </form>
</div>